

































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { UserData } from '../models/user';

@Component({
  name: 'Home',
})
export default class Home extends Vue {
  @Action('auth/logout') logoutAct!: () => Promise<void>;
  @Getter('auth/getUserData') getUserData!: () => UserData;
  @Getter('auth/getUserInitials') getUserInitials!: () => string;
  @Getter('org/getLogoUrl') getLogoUrl!: () => string;
  @Getter('org/getName') getOrgName!: () => string;
  @Getter('org/getShortName') getShortName!: () => string;

  drawer = !this.$vuetify.breakpoint.xsOnly;

  logout() {
    this.logoutAct().then(() =>
      this['$router'].push({ path: `/${this.getShortName}` })
    );
  }
}
